import React from 'react';
import VideoLinkPageTemplate from './VideoLinkPageTemplate';
import ProjectDetails from './ProjectDetails';

function ISeeYouPage() {
  const title = "I SEE YOU (2023)";
  const subtitle = "Short Film, 15mins";
  const description = "Facing imminent blindness, Andy stubbornly insists on handling his condition alone. However, his sense of independence is challenged when his sister Anna comes to visit.";
  const videoSrc = "https://www.youtube.com/embed/SYOULxypMoA";

  const credits = [
    { role: "Director", name: "ANSH PATHAPADU" },
    { role: "Director of Photography", name: "KENNETH NGUYEN" },
    { role: "Producer", name: "ROWAN ROSENBLUM" },
    { role: "Music", name: "ALEX MATTERN" },
    { role: "Editors", names: ["KENNETH NGUYEN and ANSH PATHAPADU"] }
  ];

  const keycast = [
    { role: "Andy", name: "JOSEPH BARTH" },
    { role: "Anna", name: "HANNAH NICHOLSON" },
    { role: "Dr. Gerry", name: "KERA O'BYRON" },
    { role: "Optometrist", name: "SAM DIVELY" },
    { role: "Robert", name: "JIM MONE" }
  ];

  const festivals = [
    { name: "Tokyo International Short Film Festival 2024", note: "Official Selection" },
    { name: "Cinéma Royale International Film Festival 2024", note: "Official Selection" }
  ];

  return (
    <div>
      <VideoLinkPageTemplate title={title} subtitle={subtitle} description={description} videoSrc={videoSrc} />
      
      <ProjectDetails festivals={festivals} credits={credits} cast={keycast} />

    </div>
  );
}

export default ISeeYouPage;
